<template>
  <div ref="swiper_card" class="swiper-card swiper" :class="setLayoutColor">
    <div class="swiper-wrapper">
      <div class="swiper-slide" v-for="card in cards" :key="card.id">
        <PrizeCard :title="card.name" :image="card.picture" />
      </div>
    </div>
    <div class="swiper-pagination cards__pagination"></div>
    <div class="cards__navigation">
      <div class="swiper-button-prev cards__button cards__button-prev"></div>
      <div class="swiper-button-next cards__button cards__button-next"></div>
    </div>
  </div>
</template>

<script>
import Swiper, { Navigation, Pagination } from "swiper";
import "swiper/css/bundle";
import PrizeCard from "@/components/ui/Cards/PrizeCard.vue";

export default {
  name: "SwiperCard",
  components: {
    PrizeCard,
  },
  props: {
    cards: {
      type: Array,
    },
  },
  mounted() {
    new Swiper(this.$refs.swiper_card, {
      modules: [Navigation, Pagination],
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        320: {
          slidesPerView: 1,
        },
        360: {
          slidesPerView: 1.1,
        },
        400: {
          slidesPerView: 1.2,
        },
        450: {
          slidesPerView: 1.4,
        },
        550: {
          slidesPerView: 1.7,
        },
        650: {
          slidesPerView: 2,
        },
        700: {
          slidesPerView: 2.3,
        },
        800: {
          slidesPerView: 2.6,
        },
        950: {
          slidesPerView: 3,
        },
        1000: {
          slidesPerView: 3.2,
        },
        1100: {
          slidesPerView: 3.6,
        },
        1210: {
          slidesPerView: 4,
        },
        1920: {
          slidesPerView: 5,
        },
        2560: {
          slidesPerView: 6,
        },
      },
    });
  },
  computed: {
    layoutColor() {
      return this.$store.getters.GET_LAYOUT_COLOR;
    },
    setLayoutColor() {
      return `swiper-card_${this.layoutColor}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.swiper-card {
  width: 100%;
  // height: 100%;
  height: 400px;

  :global(.swiper-pagination-bullet) {
    // background-color: $color-white;
    width: 14px;
    height: 14px;
    border-radius: 0.5rem;
    // opacity: 1;
  }

  :global(.swiper-pagination-bullet-active) {
    background-color: $color-yellow;
  }

  &_purple {
    & .cards__button {
      background-color: $color-yellow;
      color: $color-purple-10;
    }
  }

  &_red {
    & .cards__button {
      color: $color-dark-yellow;
      background-color: $color-red-30;
    }
  }
}

.cards {
  &__navigation {
    width: 176px;
    height: 80px;
    position: absolute;
    bottom: 0;
    right: 2%;
  }

  &__pagination {
    bottom: 14%;
  }

  &__button {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    top: 28%;

    &-next {
      right: 0;
    }

    &-prev {
      left: 0;
    }
  }
}

.swiper-button-next:after,
.swiper-button-prev:after {
  font-size: 40px;
  font-weight: 700;
}

@media screen and (max-width: 1210px) {
  .cards {
    &__navigation {
      display: none;
    }
  }
}
</style>
